import React from 'react';

export const TextileContentComponent = ({ children, height, width }: { children: React.ReactNode, height: string, width: string }) => (
  <div style={{ position: 'relative', width: width, height: height, padding: '35px' }}>{children}</div>
);

export default TextileContentComponent;
